import React from 'react';
import '@apollo/client';
import { useBexApi } from '@shared-ui/bex-api-context';
import { usePrepareCheckoutOperations } from '@shared-ui/multi-item-operations-providers';
import { UitkFloatingFullWidthButton, UitkSecondaryButton } from 'uitk-react-button';
import { UitkErrorSummary } from 'uitk-react-error-summary';
import { UitkPageLoader } from 'uitk-react-loader';
import { UitkSpacing } from 'uitk-react-spacing';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            }
            catch (e) {
                reject(e);
            }
        }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function () {
            if (t[0] & 1)
                throw t[1];
            return t[1];
        }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m)
        return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
    }
    catch (error) {
        e = { error: error };
    }
    finally {
        try {
            if (r && !r.done && (m = i["return"]))
                m.call(i);
        }
        finally {
            if (e)
                throw e.error;
        }
    }
    return ar;
}

var fragment = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "PrepareCheckoutFields" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "MishopUICheckoutButtonPrimer" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "text" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "accessibility" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }], "loc": { "start": 0, "end": 99, "source": { "body": "\n  fragment PrepareCheckoutFields on MishopUICheckoutButtonPrimer {\n    text\n    accessibility\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var buttonDictionary = {
    primary: UitkFloatingFullWidthButton,
    secondary: UitkSecondaryButton
};
var PrepareCheckoutButton = function (_a) {
    var data = _a.data, onClick = _a.onClick, onError = _a.onError, buttonType = _a.buttonType, className = _a.className, disabled = _a.disabled, _b = _a.isFullWidth, isFullWidth = _b === void 0 ? true : _b;
    var context = useBexApi().context;
    var prepareCheckout = usePrepareCheckoutOperations().prepareCheckout;
    var text = data.text, accessibility = data.accessibility, rest = __rest(data, ["text", "accessibility"]);
    var Button = buttonDictionary[buttonType];
    var variables = __assign({ context: context }, rest);
    /**
     * checkoutLoading state must be used instead of the loading state returned from the mutation
     * This is required because the mutation loading state will resolve before the checkout page is fully loaded
     * causing the UITK page loader to disappear prematurely
     */
    var _c = __read(React.useState(false), 2), checkoutLoading = _c[0], setCheckoutLoading = _c[1];
    var _d = __read(React.useState({
        message: '',
        description: ''
    }), 2), failureReason = _d[0], setFailureReason = _d[1];
    var continueToCheckout = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var prepareCheckoutResponse, prepareCheckoutData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onClick === null || onClick === void 0 ? void 0 : onClick();
                    setCheckoutLoading(true);
                    return [4 /*yield*/, prepareCheckout(variables, 'PREPARE_CHECKOUT')];
                case 1:
                    prepareCheckoutResponse = _a.sent();
                    if (prepareCheckoutResponse.success) {
                        prepareCheckoutData = prepareCheckoutResponse.data.prepareCheckout;
                        if (prepareCheckoutData.failureReason) {
                            onError === null || onError === void 0 ? void 0 : onError();
                            setCheckoutLoading(false);
                            setFailureReason({
                                message: prepareCheckoutData.failureReason.message,
                                description: prepareCheckoutData.failureReason.description
                            });
                        }
                        else {
                            setFailureReason({
                                message: '',
                                description: ''
                            });
                            window.location.href = prepareCheckoutData.checkoutUrl;
                        }
                    }
                    else {
                        onError === null || onError === void 0 ? void 0 : onError();
                        setCheckoutLoading(false);
                        setFailureReason({
                            message: '',
                            description: ''
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [onClick, prepareCheckout, variables, onError]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: continueToCheckout, disabled: disabled || checkoutLoading, "data-stid": "goto-checkout-button", isFullWidth: isFullWidth, className: className }, text),
        React.createElement(UitkPageLoader, { visible: checkoutLoading, title: accessibility }),
        failureReason.message && (React.createElement(UitkSpacing, { margin: { blockstart: 'three' } },
            React.createElement("div", null,
                React.createElement(UitkErrorSummary, { heading: failureReason.message, description: failureReason.description }))))));
};
PrepareCheckoutButton.fragment = fragment;
PrepareCheckoutButton.displayName = 'PrepareCheckout';

export { PrepareCheckoutButton };
